import getConfig from 'next/config';
import Script from 'next/script';

import { bugsnag } from 'shared/utils/services/bugsnag';

interface IGoogleTagScriptProps {
  cspNonce: string;
  isOneTrustEnabled: boolean;
}

/**
 * TODO: i do not think this script is even necessary and may want to talk with
 * product on removing
 */
export const GoogleTagScript = ({ cspNonce, isOneTrustEnabled }: IGoogleTagScriptProps) => {
  const { publicRuntimeConfig } = getConfig();
  const { GOOGLE_TAG_MANAGER_ID }: { GOOGLE_TAG_MANAGER_ID: string } = publicRuntimeConfig;

  return (
    <Script
      id="gtmScript"
      key="gtm"
      nonce={cspNonce}
      type={isOneTrustEnabled ? 'text/plain' : 'text/javascript'}
      className="optanon-category-C0002"
      onError={(error) => {
        bugsnag(error, { context: 'Google Inline Tag GTM Script Erroring' });
      }}
    >
      {`
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          var n = d.querySelector('[nonce]');
          n && j.setAttribute('nonce', n.nonce || n.getAttribute('nonce'));
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${GOOGLE_TAG_MANAGER_ID}');
      `}
    </Script>
  );
};
